/*eslint-disable*/
import Vue from 'vue';
import Router from 'vue-router';
import HOME from '../views/HOME';
import $Cookies from 'js-cookie'
import { MessageBox } from 'element-ui';
import { store } from '@/common/index';

Vue.use(Router);

const router = new Router({
  routes: [
    {path: '/', meta: { navShow: true,keepAlive: false },redirect:'/home', name: 'HOME', component: HOME,},
    {path: '/home', meta: { navShow: true,keepAlive: false }, name: 'HOME1', component: HOME,},
    {path: '/liveCasino',meta: { navShow: true }, name: 'liveCasino', component: ()=> import('../views/LiveCasino/liveCasino') },
    {path: '/wheel',meta: { navShow: true }, name: 'wheel', component: ()=> import('../views/wheel/wheel') },
    {path: '/sports',meta: { navShow: true }, name: 'sports', component: ()=> import('../views/game/sports/sports') },
    {path: '/esports',meta: { navShow: true }, name: 'esports', component: ()=> import('../views/game/esports/esports') },
    {path: '/deposit',meta: { navShow: false, requireAuth:true }, name: 'deposit-page', component: ()=> import('../views/deposit/deposit-page') },
    {path: '/catchFish',meta: { navShow: true }, name: 'catchFish', component: ()=> import('../views/game/catchFish/fish') },
    {path: '/chess',meta: { navShow: true }, name: 'chess', component: ()=> import('../views/game/chess/chess') },
    {path: '/lottery',meta: { navShow: true }, name: 'lottery', component: ()=> import('../views/game/lottery/lottery') },
    {path: '/privilege',meta: { navShow: true }, name: '/mine/privilege', component: ()=> import('../views/mine/minePage/privilege') },
    {path: '/agency',meta: { navShow: true }, name: 'agency', component: ()=> import('../views/agency/agency') },
    {path: '/slots', meta: { navShow: true }, name: 'slots', component: ()=> import('../views/game/Slots/slot-page'),
      // children:[
      //   {path: 'recommend',meta: { navShow: true }, name: 'recommend', component: ()=> import('../views/Slots/recommend/recommend') },
      //   {path: 'allSlot',meta: { navShow: true }, name: 'allSlot', component: ()=> import('../views/Slots/recommend/allSlot') },
      //   {path: 'hotRanking',meta: { navShow: true }, name: 'hotRanking', component: ()=> import('../views/Slots/recommend/hotRanking') },
      //   {path: 'payRanking',meta: { navShow: true }, name: 'payRanking', component: ()=> import('../views/Slots/recommend/payRanking') },
      //   {path: 'mySlots',meta: { navShow: true }, name: 'mySlots', component: ()=> import('../views/Slots/recommend/mySlots') },
      // ]
    },
    {path: '/register',meta: { navShow: true }, name: 'register', component: ()=> import('../views/mine/register/register') },
    {path: '/login',meta: { navShow: false }, name: 'login', component: ()=> import('../views/login-dialog/login-dialog') },
    // {path: '/flowDetail',meta: { navShow: true }, name: 'flowDetail', component: ()=> import('../views/discounts/detail/flowBonus') },
    // {path: '/firstBonus',meta: { navShow: true }, name: 'firstBonus', component: ()=> import('../views/discounts/detail/firstBonus') },
    // {path: '/otherBonus',meta: { navShow: true }, name: 'otherBonus', component: ()=> import('../views/discounts/detail/otherBonus') },
    {path: '/discounts',redirect: '/discounts/all',meta: { navShow: true }, name: 'discounts', component: ()=> import('../views/discounts/discounts'),
      children:[
        {path: 'all',meta: { navShow: true }, name: 'all', component: ()=> import('../views/discounts/discountPage/all') },
      ]
    },
    {path: '/discountsHall',meta: { navShow: true }, name: 'discountsHall', component: ()=> import('../views/discounts/discountsHall') },
    {path: '/download', meta: { navShow: false }, name: 'download', component: ()=> import('../views/download/download'),},
    {path: '/wallet/rechargeComplete/amount/:amount', meta: { navShow: false }, name: 'rechargeComplete', component: ()=> import('../views/mine/minePage/capital/depositComplete'),},
    {path: '/mine',redirect: '/mine/center', meta: { navShow: true,requireAuth:true }, name: 'mine', component: ()=> import('../views/mine/mine'),
      children: [
        {path: 'center',meta: { navShow: true,requireAuth:true }, name: '/mine/center', component: ()=> import('../views/mine/minePage/center') },
        {path: 'invitation',meta: { navShow: true,requireAuth:true }, name: '/mine/invitation', component: ()=> import('../views/mine/minePage/invitation') },
        {path: 'billDetail',meta: { navShow: true,requireAuth:true }, name: '/mine/billDetail', component: ()=> import('../views/mine/minePage/billDetail') },
        {path: 'safety',meta: { navShow: true,requireAuth:true }, name: '/mine/safety', component: ()=> import('../views/mine/minePage/safety') },
        {path: 'myDiscounts',meta: { navShow: true,requireAuth:true }, name: '/mine/myDiscounts', component: ()=> import('../views/mine/minePage/myDiscounts') },
        {path: 'inEmail',meta: { navShow: true,requireAuth:true }, name: '/mine/inEmail', component: ()=> import('../views/mine/inEmail/inEmail') },
        {path: 'betList',meta: { navShow: true,requireAuth:true }, name: '/mine/betList', component: ()=> import('../views/mine/minePage/betList') },
        {path: 'getBonus',meta: { navShow: true,requireAuth:true }, name: '/mine/getBonus', component: ()=> import('../views/mine/getBonus/getBonus') },
        {path: 'capital',redirect: '/mine/capital/account',meta: { navShow: true,requireAuth:true }, name: '/mine/capital', component: ()=> import('../views/mine/minePage/capital'),
          children:[
            {path: 'account',meta: { navShow: true,requireAuth:true }, name: '/mine/capital/account', component: ()=> import('../views/mine/minePage/capital/account') },
            {path: 'deposit',meta: { navShow: true,requireAuth:true }, name: '/mine/capital/deposit', component: ()=> import('../views/mine/minePage/capital/deposit') },
            {path: 'withdrawal',meta: { navShow: true,requireAuth:true }, name: '/mine/capital/withdrawal', component: ()=> import('../views/mine/minePage/capital/withdrawal') },
            {path: 'bankList',meta: { navShow: true,requireAuth:true }, name: '/mine/capital/bankList', component: ()=> import('../views/mine/minePage/capital/bankList') },
            {path: 'alipayList',meta: { navShow: true,requireAuth:true }, name: '/mine/capital/alipayList', component: ()=> import('../views/mine/minePage/capital/alipayList') },
            {path: 'usdtList',meta: { navShow: true,requireAuth:true }, name: '/mine/capital/usdtList', component: ()=> import('../views/mine/minePage/capital/usdtList') },
            {path: 'withdrawalList',meta: { navShow: true,requireAuth:true }, name: '/mine/capital/withdrawalList', component: ()=> import('../views/mine/minePage/capital/withdrawalList') },
            {path: 'dispositRecord',meta: { navShow: true,requireAuth:true }, name: '/mine/capital/dispositRecord', component: ()=> import('../views/mine/minePage/capital/dispositRecord') },
            {path: 'lockAmount',meta: { navShow: true,requireAuth:true }, name: '/mine/capital/lockAmount', component: ()=> import('../views/mine/minePage/capital/lockAmount') },
          ]
        },
        // 余额宝
        {path: 'yuebao',meta: { navShow: true,requireAuth:true }, name: '/mine/yuebao', component: ()=> import('../views/mine/yuebao/yuebao') },
      ]
    },
    // {path: '/inEmail',meta: { navShow: true, requireAuth:true }, name: 'inEmail', component: ()=> import('../views/mine/inEmail/inEmail') },

    {path: '/helpCenter', redirect: '/helpCenter/startUse', meta: { navShow: true }, name: 'helpCenter', component: ()=> import('../views/helpCenter/helpCenter'),
      children: [
        {path: 'startUse',meta: { navShow: true}, name: '/helpCenter/startUse', component: ()=> import('../views/helpCenter/pages/startUse') },
      ]
    },
    
    { path: '/404',meta: { navShow: false,asideHide:true },name:'404',component: ()=> import('../../../common/notfound/404')},
    { path: '/500',meta: { navShow: false,asideHide:true },name:'500',component: ()=> import('../../../common/notfound/500')},
    { path: '*',meta: { navShow: false,asideHide:true},name:'notfound',component: ()=> import('../../../common/notfound/404')},
  ], 
  // scrollBehavior (to, from, savedPosition) {
  //   if (savedPosition) {
  //     return savedPosition
  //   } else {
  //     return { x: 0, y: 0 }
  //   }
  // }
});

function Message() {
  MessageBox('请先登录', '温馨提示', {
    confirmButtonText: '确定',
  });
}

router.beforeEach(function (to, from, next) {
  if(to.matched.some(r => r.meta.requireAuth )){
    if(store.state.isLogin){
      next();
    }else {
      if($Cookies.get('UUID')){
        next();
      }else {
        Message();
        next({
          path: '/home',
          query: {redirect: to.fullPath}
        })
      }
    }
  } else {
    next();
  }
  if (_hmt) {
    if (to.path) {
        _hmt.push(['_trackPageview', '/#' + to.fullPath]);
    }
  }
});

router.afterEach(function (to) {
  // 重置登陆框
  store.dispatch('JIN_SHA_GLOBAL_LOGIN', false);

  let fullPath = to.fullPath;
  if(fullPath.indexOf('/home') > -1) {
    store.dispatch('sports_setTopNav', true)
  }else {
    store.dispatch('sports_setTopNav', false)
  }
})

export default router



// WEBPACK FOOTER //
// ./src/pages/build08/router/index.js